import Layout from "../Layout";
import { FaImage } from "react-icons/fa";
import { FaSave } from "react-icons/fa";

import { useState, useEffect } from "react";
import axios from "axios";
import { codigoEvento } from "../Utils/utils";

function Evento() {
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Evento`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setImagePreview(`data:image/png;base64,${res.data.LOGO}`);
          setInfoAdicional(res.data.INFOADIC || "");
          setNomeEvento(res.data.NOMEEVENTO || "");
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [nomeEvento, setNomeEvento] = useState("");
  const [infoAdicional, setInfoAdicional] = useState("");

  async function handleAddImage(e) {
    const file = e.target.files[0];
    if (!file) return;

    setImage(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);

      let data = {
        logo: reader.result ? reader.result.split(",")[1] : null,
        codigoAluguel: codigoEvento(),
      };
      axios
        .put(`${process.env.REACT_APP_API_URL}/Evento`, data, {
          headers: { auth: process.env.REACT_APP_API_TOKEN },
        })
        .then((res) => {
          window.location.reload(true);
        });
    };
    reader.readAsDataURL(file);
  }

  async function handleSubmit() {
    let data = {
      nomeEvento: nomeEvento,
      infoAdic: infoAdicional,
      codigoAluguel: codigoEvento(),
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}/Evento`, data, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
      })
      .then((res) => {
        window.location.reload(true);
      });
  }
  return (
    <Layout>
      <div className="font-Roboto flex flex-col box-border p-4 lg:p-12 gap-12 w-full">
        <div className="flex flex-col gap-2 justify-center items-center">
          <h1 className="font-Oswald">Dados do meu evento</h1>
        </div>

        <form
          className="flex flex-col gap-8 w-full box-border"
          onSubmit={(event) => {
            event.preventDefault();
            handleSubmit();
          }}
        >
          <div className="flex flex-col gap-8 justify-center items-center">
            <img
              width="120px"
              src={imagePreview}
              alt=""
              style={{ filter: "grayscale(100%)" }}
            />{" "}
            <label
              htmlFor="image"
              className="flex p-4 text-base text-white items-center rounded-lg bg-[#2185D0] gap-2 transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
            >
              <FaImage size={20} />
              <span>Atualizar imagem</span>
            </label>
            <input
              onChange={handleAddImage}
              name="image"
              id="image"
              className="hidden"
              type="file"
              accept=".jpg, .jpeg, .png"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="nomeEvento" className="text-sm font-bold">
              Nome do Evento
            </label>
            <input
              name="nomeEvento"
              value={nomeEvento}
              onChange={(e) => {
                setNomeEvento(e.target.value);
              }}
              className="font-Roboto p-2 text-base rounded-lg border border-solid border-gray-200"
              type="text"
            ></input>
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="infoAdicional" className="text-sm font-bold">
              Informações adicionais
            </label>
            <input
              name="infoAdicional"
              value={infoAdicional}
              onChange={(e) => {
                setInfoAdicional(e.target.value);
              }}
              className="font-Roboto p-2 text-base rounded-lg border border-solid border-gray-200"
              type="text"
            ></input>
          </div>

          <button className="flex w-fit gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto">
            <FaSave />
            <span>Salvar</span>
          </button>
        </form>
      </div>
    </Layout>
  );
}
export default Evento;
